import { openBlock as t, createElementBlock as h, createStaticVNode as e } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ e('<path fill="#496E2D" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M27.826 20H20v20c2.338 0 4.581-.403 6.667-1.14L27.827 20Z"></path><path fill="#FF9811" d="M33.334 34.906A19.948 19.948 0 0 0 40 20h-7.826l1.16 14.906Z"></path><path fill="#000" d="M26.667 20v18.86a19.989 19.989 0 0 0 6.667-3.954V20h-6.667Z"></path><path fill="#FF9811" d="M36.957 13.043h-5.218a1.74 1.74 0 0 0-3.478 0h-5.217c0 .961.836 1.74 1.797 1.74h-.058c0 .96.778 1.739 1.739 1.739 0 .96.778 1.739 1.739 1.739h3.478c.96 0 1.74-.779 1.74-1.74.96 0 1.739-.778 1.739-1.738h-.058c.96 0 1.797-.779 1.797-1.74Z"></path>', 5), l = [
  c
];
function o(i, n) {
  return t(), h("svg", a, [...l]);
}
const d = { render: o };
export {
  d as default,
  o as render
};
